import { extractItemName } from "../utils/expenseDraftModal";
import {
  useAddExpenseDescription,
  useReactivateExpenseDescription,
} from "./useExpenses";
import { ExpenseDescription } from "@/types/expenseDescription";
import { ExpenseDraftFormValue } from "../types/expenseDraft";

interface HandleOperationProps {
  values: ExpenseDraftFormValue;
  onSuccess?: (data: ExpenseDescription) => void;
  onError?: () => void;
}

export const useExpenseDescription = () => {
  const { mutate: addExpenseDescription } = useAddExpenseDescription();
  const { mutate: reactivateExpenseDescription } =
    useReactivateExpenseDescription();

  const handleAddExpenseDescription = ({
    values,
    onSuccess,
    onError,
  }: HandleOperationProps): Promise<void> => {
    const descriptionName = extractItemName(
      values.description_id || "",
      "new-"
    );

    return new Promise((resolve) => {
      addExpenseDescription(
        {
          name: descriptionName,
          unit_id: values.unit_id,
          expense_type_id: values.expense_type_id,
        },
        {
          onSuccess: (data: ExpenseDescription) => {
            onSuccess?.(data);
            resolve();
          },
          onError: () => onError?.(),
        }
      );
    });
  };

  const handleReactivateExpenseDescription = ({
    values,
    onSuccess,
    onError,
  }: HandleOperationProps): Promise<void> => {
    const descriptionId = extractItemName(
      values.description_id || "",
      "inactive-"
    );

    return new Promise((resolve) => {
      reactivateExpenseDescription(descriptionId, {
        onSuccess: (data: ExpenseDescription) => {
          onSuccess?.(data);
          resolve();
        },
        onError: () => onError?.(),
      });
    });
  };
  return {
    handleAddExpenseDescription,
    handleReactivateExpenseDescription,
  };
};

export default useExpenseDescription;
